module.exports = __webpack_public_path__ + "img/MG-University.c561142a.jpg";